<wl-content-section [theme]="theme()">
  <wl-generic-form-section [rendering]="rendering()" />
</wl-content-section>
